import React, { useState } from "react";
import axios from "axios";
import { Done, DoneAll, GetApp } from "@material-ui/icons";
import Fab from "@material-ui/core/Fab";

import { ErrorData } from "../../helpers/helper";
import ReplyIcon from "@material-ui/icons/Reply";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  myMessage: {
    float: "right",
    margin: 5,
  },
  otherMessage: {
    float: "left",
    margin: 5,
  },
});
const PrescriptionMessage = ({
  chat,
  UserId,
  reply,
  deleteMessage,
  doc,
  prescriptionFileStyle,
  prescriptionFileStyle2,
}) => {
  const [file, setFile] = useState({});
  const [downloaded, setDownloaded] = useState(false);
  const owner = parseInt(UserId) === parseInt(chat.user_id);
  const [process, setProcess] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const classes = useStyles();

  return (
    <div key={chat.key} className={owner ? "chat_item me" : "chat_item"}>
      <div className="main_item_chat" style={prescriptionFileStyle}>
        <div className="text_chat" style={prescriptionFileStyle2}>
          <p>{doc}</p>
          <p>{chat.message}</p>
        </div>
        <div className="clearfix" />
        <time>{chat.created_at}</time>
        {owner ? (
          <span className="seen">{chat.seen ? <DoneAll /> : <Done />}</span>
        ) : null}
        <div className="clearfix" />
      </div>
      {owner ? (
        <div className="control_message" style={{ display: "inline" }}>
          <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
          <DeleteIcon
            className="delete_message"
            onClick={() => deleteMessage(chat)}
          />{" "}
        </div>
      ) : (
        <div
          className="control_message"
          style={{ display: "inline", float: "left" }}
        >
          <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
        </div>
      )}
      <div className="clearfix" />
    </div>
  );
};

export default PrescriptionMessage;
